export const CURRENCIES = [
  { code: "USD", name: "US Dollar", symbol: "$", country: "United States" },
  { code: "EUR", name: "Euro", symbol: "€", country: "European Union" },
  { code: "GBP", name: "British Pound", symbol: "£", country: "United Kingdom" },
  { code: "JPY", name: "Japanese Yen", symbol: "¥", country: "Japan" },
  { code: "CHF", name: "Swiss Franc", symbol: "CHF", country: "Switzerland" },
  { code: "CAD", name: "Canadian Dollar", symbol: "C$", country: "Canada" },
  { code: "AUD", name: "Australian Dollar", symbol: "A$", country: "Australia" },
  { code: "NZD", name: "New Zealand Dollar", symbol: "NZ$", country: "New Zealand" },
  { code: "CNY", name: "Chinese Yuan", symbol: "¥", country: "China" },
  { code: "HKD", name: "Hong Kong Dollar", symbol: "HK$", country: "Hong Kong" },
  { code: "SGD", name: "Singapore Dollar", symbol: "S$", country: "Singapore" },
  { code: "INR", name: "Indian Rupee", symbol: "₹", country: "India" },
  { code: "KRW", name: "South Korean Won", symbol: "₩", country: "South Korea" },
  { code: "TWD", name: "Taiwan Dollar", symbol: "NT$", country: "Taiwan" },
  { code: "BRL", name: "Brazilian Real", symbol: "R$", country: "Brazil" },
  { code: "MXN", name: "Mexican Peso", symbol: "MX$", country: "Mexico" },
  { code: "ARS", name: "Argentine Peso", symbol: "AR$", country: "Argentina" },
  { code: "CLP", name: "Chilean Peso", symbol: "CL$", country: "Chile" },
  { code: "COP", name: "Colombian Peso", symbol: "CO$", country: "Colombia" },
  { code: "PEN", name: "Peruvian Sol", symbol: "S/", country: "Peru" },
  { code: "ZAR", name: "South African Rand", symbol: "R", country: "South Africa" },
  { code: "AED", name: "UAE Dirham", symbol: "د.إ", country: "UAE" },
  { code: "SAR", name: "Saudi Riyal", symbol: "﷼", country: "Saudi Arabia" },
  { code: "QAR", name: "Qatari Riyal", symbol: "QR", country: "Qatar" },
  { code: "KWD", name: "Kuwaiti Dinar", symbol: "KD", country: "Kuwait" },
  { code: "BHD", name: "Bahraini Dinar", symbol: "BD", country: "Bahrain" },
  { code: "OMR", name: "Omani Rial", symbol: "OMR", country: "Oman" },
  { code: "JOD", name: "Jordanian Dinar", symbol: "JD", country: "Jordan" },
  { code: "EGP", name: "Egyptian Pound", symbol: "E£", country: "Egypt" },
  { code: "TRY", name: "Turkish Lira", symbol: "₺", country: "Turkey" },
  { code: "RUB", name: "Russian Ruble", symbol: "₽", country: "Russia" },
  { code: "PLN", name: "Polish Zloty", symbol: "zł", country: "Poland" },
  { code: "CZK", name: "Czech Koruna", symbol: "Kč", country: "Czech Republic" },
  { code: "HUF", name: "Hungarian Forint", symbol: "Ft", country: "Hungary" },
  { code: "RON", name: "Romanian Leu", symbol: "lei", country: "Romania" },
  { code: "SEK", name: "Swedish Krona", symbol: "kr", country: "Sweden" },
  { code: "NOK", name: "Norwegian Krone", symbol: "kr", country: "Norway" },
  { code: "DKK", name: "Danish Krone", symbol: "kr", country: "Denmark" },
  { code: "ISK", name: "Icelandic Krona", symbol: "kr", country: "Iceland" },
  { code: "THB", name: "Thai Baht", symbol: "฿", country: "Thailand" },
  { code: "MYR", name: "Malaysian Ringgit", symbol: "RM", country: "Malaysia" },
  { code: "IDR", name: "Indonesian Rupiah", symbol: "Rp", country: "Indonesia" },
  { code: "PHP", name: "Philippine Peso", symbol: "₱", country: "Philippines" },
  { code: "VND", name: "Vietnamese Dong", symbol: "₫", country: "Vietnam" },
  { code: "PKR", name: "Pakistani Rupee", symbol: "₨", country: "Pakistan" },
  { code: "BDT", name: "Bangladeshi Taka", symbol: "৳", country: "Bangladesh" },
  { code: "LKR", name: "Sri Lankan Rupee", symbol: "Rs", country: "Sri Lanka" },
  { code: "NGN", name: "Nigerian Naira", symbol: "₦", country: "Nigeria" },
  { code: "KES", name: "Kenyan Shilling", symbol: "KSh", country: "Kenya" },
  { code: "GHS", name: "Ghanaian Cedi", symbol: "GH₵", country: "Ghana" },
  { code: "ILS", name: "Israeli Shekel", symbol: "₪", country: "Israel" },
  { code: "UAH", name: "Ukrainian Hryvnia", symbol: "₴", country: "Ukraine" },
  { code: "BGN", name: "Bulgarian Lev", symbol: "лв", country: "Bulgaria" },
  { code: "HRK", name: "Croatian Kuna", symbol: "kn", country: "Croatia" },
  { code: "RSD", name: "Serbian Dinar", symbol: "din", country: "Serbia" },
];

// Fetch live conversion rate from a free API
let rateCache: Record<string, { rate: number; ts: number }> = {};
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export async function getConversionRate(from: string, to: string): Promise<number> {
  if (from === to) return 1;
  const key = `${from}_${to}`;
  const cached = rateCache[key];
  if (cached && Date.now() - cached.ts < CACHE_TTL) return cached.rate;

  try {
    const res = await fetch(`https://api.exchangerate.host/live?access_key=free&source=${from}&currencies=${to}`);
    const data = await res.json();
    if (data?.quotes?.[`${from}${to}`]) {
      const rate = data.quotes[`${from}${to}`];
      rateCache[key] = { rate, ts: Date.now() };
      return rate;
    }
    // Fallback: try another free API
    const res2 = await fetch(`https://open.er-api.com/v6/latest/${from}`);
    const data2 = await res2.json();
    if (data2?.rates?.[to]) {
      const rate = data2.rates[to];
      rateCache[key] = { rate, ts: Date.now() };
      return rate;
    }
  } catch (e) {
    console.warn("Failed to fetch conversion rate:", e);
  }
  return 1;
}

export function getCurrencySymbol(code: string): string {
  return CURRENCIES.find((c) => c.code === code)?.symbol || code;
}
